'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import type { CompanyResource } from '../api';
import { getImageURL } from '@/utils/helper';
import { useDebouncedWindowSize } from './VideoDetail';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';


export default function Index({ data }: { data?: CompanyResource[] }) {
  const { width } = useDebouncedWindowSize();
  const items = data?.map((item) => {
    return (
      <SwiperSlide key={item.id}>
        <Image
          src={getImageURL(item.url)} 
          alt="图片" 
          width={375} 
          height={210}
          quality={100}
          style={{ width: width - 30, height: ((width - 30) * 9) / 16 }} 
        />
      </SwiperSlide>
    );
  });
  if (!data?.length) {
    return null;
  }
  return (
    <div className="mb-[20px]">
      <Swiper modules={[Pagination, Autoplay]} autoplay={{delay: 5000}} loop pagination={{ clickable: true }}>
        {items}
      </Swiper>
    </div>
  );
}
